// tunAsm.js
var TunAsm = pc.createScript('tunAsm');

// initialize code called once per entity
// 
// 

var rot;
var prevMargin;
var pps = 0;

TunAsm.attributes.add("cam", {type: "entity", title: "Camera"});
TunAsm.attributes.add("rotSpd", {type: "number", title: "Cam Rotation Speed"});
TunAsm.attributes.add("range", {type: "number", title: "Range"});
TunAsm.attributes.add("twnTime", {type: "number", title: "Tween Time"});
TunAsm.attributes.add("mInterv", {type: "number", title: "spawn Intervall"});
TunAsm.attributes.add("assets", {type: "entity", array : true});



TunAsm.prototype.initialize = function() {
  this.rot = 0;
  this.time = 0;
  this.spawnNext = this.mInterv; // spawn intervall!!!
  this.prevMargin = 19.5;
  this.pps = this.range / this.twnTime;
};

// update code called every frame
TunAsm.prototype.update = function(dt) {
 // this.rot += ;
  this.root.rotate(0,0,this.rotSpd);
  this.time += dt;
    
    if (this.time > this.spawnNext) {
        this.spawnNext = this.time + this.mInterv;
        this.spawn ();
    }
};


TunAsm.prototype.spawn = function () {
    
    var rnd = Math.floor(Math.random() * this.assets.length);
    var cEnt = this.assets[rnd].clone();
    var startPos = this.entity.getPosition();
    var tTime = 0;
    var prvPos = 0;
        
    this.prvPos = this.mInterv * this.pps;
    startPos.z += prvPos - this.prevMargin /2;
    tTime = startPos.z / this.pps * -1;
    cEnt.setPosition(0,0,this.startPos);
    cEnt.rotate(0,0,Math.floor(Math.random() * 6) * 60);
    
    
    
    this.app.root.addChild(cEnt);
    
    console.log("startPos" + startPos + " prvPos: " + prvPos + " pps: " + pps + " tTime: " + tTime);
    
    cEnt
    .tween(startPos)
    .to({x: 0, y: 0, z: this.entity.getPosition().z}, this.twnTime, pc.Linear)
    .on('complete', function () {
       TunAsm.prototype.resetter(cEnt);
    })
    .start();
    prevMargin = cEnt.children[1].getLocalPosition().z;
 };

TunAsm.prototype.resetter = function (ent) {
    ent.destroy();
};

// swap method called for script hot-reloading
// inherit your script state here
// TunAsm.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

